import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssueWorkflowEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-workflow-edit',
	path: '/jira/settings/issues/workflows/:workflowId',
};
